/**
 * Simplified Chinese (CNY + SGD) mock schedules for the scheduled-transactions
 * use case. A schedule with both source and destination accounts is a schedule
 * pair, rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_ZH_CN = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 12500,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		displayAccount: '常青银行',
		displayFreq: 'Monthly',
		description: '返利卡还款',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 11000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		displayAccount: '常青银行',
		displayFreq: 'Monthly',
		description: '房租',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 10400,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		displayAccount: '常青银行',
		displayFreq: 'Monthly',
		description: '基金定投',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 35000,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		displayAccount: '常青银行',
		displayFreq: 'Monthly',
		description: '工资',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 5200,
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		displayAccount: '常青银行',
		displaySourceAccount: '常青银行',
		displayDestAccount: '定期存款',
		displayFreq: 'Monthly',
		description: '存入储蓄',
		pairedType: 'Transfer',
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 2,
	},
];
